const state = {
  menuItems: [],
};

const getters = {
  menuItems: state => state.menuItems,
};

const mutations = {};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
